import React from 'react';
import {
  getFiltersInfo,
  setFiltersInfo
} from '../../../../common/utils/FiltersInfo';
import { numberFormat } from '../../../../common/constants/NumberFormat';
import { navigate } from 'gatsby';
import moment from 'moment';

const BankDisbursementColumnData = (filteredProduct, changeMonth, bank) => {
  const commonHeaderStyle = 'items-end mx-auto ',
    commonStyle = 'w-full mx-3',
    totalCommonStyle = 'w-full  font-bold mx-3 ',
    commonparentGruopStyle =
      '  mx-auto text-center  mb-2 text font-khand font-sm text-black-500 font-semibold absolute ',
    commonColStyle =
      ' mt-2 text-black-500 text-sm  font-khand font-normal overflow-auto';

  const commonParentGroupStyle = {
    fontWeight: 500,
    fontSize: '14px',
    bottom: '34px'
  };
  const colStyle = { fontWeight: '500', opacity: '0.8' };

  const HeaderCommonFormat = ({
    majorColName = '',
    colName,
    colNameClass = '',
    passclass = ''
  }) => (
    <div className={`${commonHeaderStyle} ${passclass}`}>
      <p
        className={`${commonparentGruopStyle} `}
        style={commonParentGroupStyle}
      >
        {majorColName}
      </p>
      <p
        className={`${commonColStyle} ${colNameClass} 
        
        `}
        style={colStyle}
      >
        {colName}
      </p>
    </div>
  );

  function addToLocalStorage(status, row) {
    let filtersData = getFiltersInfo();
    let newFilterData = {
      ...filtersData,
      rmId: '',
      productId: filteredProduct ? parseInt(filteredProduct) : '',
      status: status,
      targetMonth: null,
      backPage: 'bankDisbursementReport',
      disbursedMonth: changeMonth || {
        year: parseInt(moment().format('YYYY')),
        month: parseInt(moment().format('MM'))
      },
      bankFilter: bank?.value ? bank : { value: row?.bankId },
      productType: null
    };
    setFiltersInfo(newFilterData);
    navigate(`/app/dashboard`);
  }

  return [
    {
      name: (
        <HeaderCommonFormat
          colName="Bank Name"
          passclass="text-left w-48 ml-3"
        />
      ),
      selector: 'bankName',
      sortable: false,
      cell: row => {
        if (row?.isTotal)
          return (
            <p className="w-full font-bold text-base  text-left mx-3">Total</p>
          );
        return (
          <p className={`${commonStyle} text-left`}>
            {row?.bankName ? row?.bankName : '---'}
          </p>
        );
      },
      maxWidth: '192px !important'
    },

    {
      name: (
        <HeaderCommonFormat
          colName="Number of Disbursement"
          passclass="text-center"
        />
      ),
      selector: 'numOfDisbursement',
      sortable: false,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } ${row?.totalDisbursed &&
            'cursor-pointer'} text-blue-900 text-center`}
          onClick={() =>
            row?.totalDisbursed && addToLocalStorage('Disbursed', row)
          }
        >
          {row?.totalDisbursed || 0}
        </p>
      ),
      maxWidth: '100px !important'
    },
    {
      name: (
        <HeaderCommonFormat
          colName="Disbursed Amount"
          passclass="text-right w-40 pr-5"
        />
      ),
      selector: 'disbursedAmount',
      sortable: false,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          }  break-normal text-right `}
        >
          <span className="ml-1">
            &#8377;
            {numberFormat(row?.disbursedAmount) || 0}
          </span>
        </p>
      ),
      maxWidth: '150px !important'
    },
    {
      name: <HeaderCommonFormat passclass="text-right w-28" colName="GR" />,
      selector: 'GR',
      sortable: false,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } break-normal text-right `}
        >
          <span className="ml-1"> &#8377; {numberFormat(row?.gr) || 0}</span>
        </p>
      ),
      maxWidth: '150px !important'
    }
  ];
};

export default BankDisbursementColumnData;
